import {Component, OnInit} from '@angular/core';
import fullNotifyIcon from '@iconify/icons-mdi/bell';
import emptyNotifyIcon from '@iconify/icons-mdi/bell-outline';
import {WebsocketService} from '../../services/websocket/websocket.service';
import {Notification} from 'shared';
import {NotificationService} from '../../stores/notification.service';
import DataSource from 'devextreme/data/data_source';
import {Notice} from '@pnotify/core';

@Component({
  selector: 'app-notifications-panel',
  templateUrl: './notifications-panel.component.html',
  styleUrls: ['./notifications-panel.component.scss']
})
export class NotificationsPanelComponent implements OnInit {

  notifyIcon = emptyNotifyIcon;
  ds: DataSource;
  total = '0';

  constructor(
    private service: NotificationService,
    private ws: WebsocketService,
  ) {
    // Data source
    this.ds = service.newDataSource({
      pageSize: 20,
    });

    // Load data
    this.ds.load();

    this.ds.on('loadingChanged', (isLoading) => {
      if (!isLoading) {
        const l = this.ds.items().filter(n => n.read === false).length;
        this.total = l >= 20 ? '20+' : l.toString();
      }
    });

    // Interventions status events
    ws.topicObserver('Notification', Notification).subscribe((e) => {
      this.ds.reload();
      const notification = e as Notification;
      notification.show((notice: Notice) => {
        this.service.navigation.next(notification);
        notice.close();
      });
    });

    // Bindings
    this.readAll = this.readAll.bind(this);
    this.reload = this.reload.bind(this);
  }

  ngOnInit(): void {
  }

  itemClick(e: any) {
    const notification = e.itemData;
    this.service.update(notification.id, null).subscribe(() => {
      this.ds.reload();
      this.service.navigation.next(notification);
    });
  }

  contextMenuClick(e: any) {
    const id = e.itemData.id;
    switch (e.itemData.action) {
      case 'read':
        this.service.update(id, null).subscribe(() => {
          this.ds.reload();
        });
        break;
    }
  }

  readAll(e: any) {
    this.service.readAll().subscribe(() => {
      this.ds.reload();
    });
  }

  reload(e: any) {
    this.ds.reload();
  }
}
